import React from 'react';

const LogicOp = ({operator}) => (
    <>
        <span className="logic-op ml-1 mr-1 text-uppercase">{operator}</span>
    </>
);

export default LogicOp;
